"use client";

import Link from "next/link";
import { motion } from "framer-motion";

export default function BusinessSetupSection() {
  return (
    <section className="relative bg-[#FAFAFA] py-12 sm:py-16 lg:py-20 xl:py-24 px-4 overflow-hidden">

      <div className="main-container">

        {/* HEADER */}
        <div className="text-left md:text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-400 mb-3">
            Business Setup
          </p>

          <h1
            className="font-bold text-[#000000]"
            style={{ 
              fontSize: "clamp(28px, 5vw, 48px) ",
              fontWeight: "700",
              lineHeight: "1.3"
            }}
          >
            Packages & Costs
          </h1>

          <p 
            className="text-gray-500 mt-5 max-w-3xl md:mx-auto"
            style={{ 
              fontSize: "clamp(14px, 1.2vw, 16px)",
              lineHeight: "1.6"
            }}
          >
            A clear, transparent view of how Business Setup in Dubai is priced. Figures below are indicative and vary by activity, shareholder structure, visa count and jurisdiction. For a precise, itemised total, use the calculator and speak with a specialist.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 xl:gap-10 2xl:gap-14 max-w-[2000px] mx-auto">

          {/* CARD */}
          {[
            {
              title: "Free Zone cost overview",
              price: "Starting from AED 12,500",
              desc: "A simple free zone company with no visas typically starts from AED 12,500. The final amount varies with your chosen activities, the number of visas, the type of office and the rules of the selected authority.",
            },
            {
              title: "Mainland cost overview",
              price: "Starting from AED 14,999",
              desc: "A straightforward mainland license with no visas typically starts from AED 14,999. The final amount varies with the emirate, your activities and any external approvals, the number of visas and your office lease.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group bg-[#fafafa] border border-gray-100 rounded-3xl p-6 md:p-8 shadow-xl transition-all duration-300 flex flex-col h-full"
            >

              {/* TOP */}
              <div className="flex items-start justify-between mb-4">

                <h3 
                  className="font-semibold text-black group-hover:text-[#B8893A] transition"
                  style={{ 
                    fontSize: "clamp(18px, 2vw, 20px)",
                    fontWeight: "600"
                  }}
                >
                  {item.title}
                </h3>

                <span className="text-xs font-bold text-[#B8893A] bg-[#B8893A]/10 px-3 py-1.5 rounded-full">
                  {i === 0 ? "FZ" : "ML"}
                </span>

              </div>

              {/* PRICE */}
              <p className="text-[#B8893A] font-semibold text-sm mb-4">
                {item.price}
              </p>

              {/* LINE */}
              <div className="h-px bg-gray-100 my-6"></div>

              {/* DESC */}
              <div className="flex-grow mb-8">
                <p 
                  className="text-gray-500"
                  style={{ 
                    fontSize: "clamp(14px, 1.2vw, 16px)",
                    lineHeight: "1.6"
                  }}
                >
                  {item.desc}
                </p>
              </div>

              {/* CTA */}
              <div className="mt-auto">
                <Link href="/calculator">
                  <button className="w-full bg-[#B8893A] hover:bg-[#A67B34] text-white text-sm font-semibold px-6 py-3 rounded-xl transition-all hover:scale-105">
                    Calculate Cost
                  </button>
                </Link>
              </div>

            </motion.div>
          ))}
           
        </div>

      </div>

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>

    </section>
  );
}
